//TIMEOUTS EN MILISEGUNDOS
const POPUP_TIMEOUT_STARRED = 10000;
const POPUP_TIMEOUT_FOLLOWING = 5000;
const POPUP_TIMEOUT_OPINION = 10000;
const POPUP_TIMEOUT_CREATE_COMMENT = 5000;
const POPUP_TIMEOUT_LIKE_COMMENT = 5000;
const POPUP_TIMEOUT_CONTEST = 10000;
const POPUP_TIMEOUT_EVENT = 10000;
const POPUP_TIMEOUT_REGISTER = 15000; //DEF
//const POPUP_TIMEOUT_REGISTER = 60000;
const POPUP_TIMEOUT_LOGIN = 60000; //DEF
//const POPUP_TIMEOUT_LOGIN = 3000;

//const EXPIRE_COOKIE_POPUP_TIME = 180000; //3 MINUTOS
const EXPIRE_COOKIE_POPUP_TIME = 2592000000; //30 DIAS (DEF)

const app = Voonto.getInstance();
const vocUserNotificationsPath = app.lookup('vocento.config.nibara').vocUserNotifications;

var savedData = false;

    export function getTimeoutPopup($btn){
        switch ($btn){
            case 'starred':
                return POPUP_TIMEOUT_STARRED;
                break;
            case 'following':
                return POPUP_TIMEOUT_FOLLOWING;
                break;
            case 'event':
                return POPUP_TIMEOUT_EVENT;
                break;
            case 'contest':
                return POPUP_TIMEOUT_CONTEST;
                break;
            case 'new-comment':
                return POPUP_TIMEOUT_CREATE_COMMENT;
                break;
            case 'like-comment':
                return POPUP_TIMEOUT_LIKE_COMMENT;
                break;
            case 'opinion':
                return POPUP_TIMEOUT_OPINION;
                break;
            case 'register':
                return POPUP_TIMEOUT_REGISTER;
                break;
            default:
                return POPUP_TIMEOUT_LOGIN;
                break;
        }
    }

    export function parseUrl(url) {
        var parser = document.createElement('a');
        parser.href = url;
        return {
            protocol:parser.protocol,
            host:parser.host,
            hostname:parser.hostname,
            port:parser.port,
            pathname:parser.pathname,
            hash:parser.hash,
            search:parser.search,
            origin:parser.origin
        }
    }

    export function createCSData($elm){
        Logger.debug('[post-script] createCSData - $elm >> ' + $elm.data('btn'));
        var serviceId = '';
        var serviceReference = '';
        var url = parseUrl(document.location.href);
        var pathname = url.pathname;
        var section = '';
        var host = location.host;
        // (host == 'abcblogsv2.abc.es' || host == 'pre-abcblogsv2.abc.es')
        if (pathname == '' || pathname == '/') {
            section = "home";
        } else if (host.match(/abcblogsv2/gi)) {
            section = 'blogs';
        } else {
            var res = pathname.split("/");
            section = res[1];
        }
        if($elm.data('btn') === 'starred'){
            serviceId = '190';
            serviceReference = section;
        }else if ($elm.data('btn') === 'following'){
            serviceId = '195';
            if (section === 'play'){
                serviceReference = $elm.parent().find('.nombre a').attr('title');
            }else{
                serviceReference = $elm.parent().find('.autor').attr('title');
            }
            Logger.debug('[post-script] createCSData - serviceReference >> ' + serviceReference);
            if ('undefined' === typeof serviceReference) {
                var vocUserNotificationsPath = app.lookup('vocento.config.nibara').vocUserNotifications;
                Logger.debug('[post-script] createCSData - vocUserNotificationsPath >> ' + vocUserNotificationsPath);
                Logger.debug('[post-script] createCSData - section >> ' + section);
                if (vocUserNotificationsPath !== undefined) {
                    serviceReference = section;
                }
            }
            Logger.debug('[post-script] createCSData - serviceReference >> ' + serviceReference);
            serviceReference = serviceReference.normalize("NFKD").replace(/[\u0300-\u036F]/g, "").replace(/ /g,"_");
        }
        return {
            serviceId:serviceId,
            serviceReference:serviceReference
        }
    }

    export function getInitialText($btn){
        var initialText = "Queremos conocerte";
        switch ($btn){
            case 'starred':
                initialText = 'Has guardado el artículo correctamente, ahora queremos conocerte mejor';
                break;
            case 'following':
                initialText = 'Nos complace saber que sigues a nuestros autores, ahora queremos conocerte mejor';
                break;
            case 'event':
                initialText = 'Ya estás apuntado para el evento, ahora queremos conocerte mejor';
                break;
            case 'contest':
                initialText = 'Ya estás participando en el concurso, ahora queremos conocerte mejor';
                break;
            case 'new-comment':
                initialText = 'Tu comentario se ha publicado correctamente, ahora nos gustaría conocerte mejor';
                break;
            case 'like-comment':
                initialText = 'Tu valoración del comentario se ha guardado correctamente, ahora nos gustaría conocerte mejor';
                break;
            case 'opinion':
                initialText = 'Queremos conocerte';
                break;
        }
        $('.popup_info').find('.textevent').text(initialText);
    }

    export function createPopupCookie($elm) {
        var expires = new Date();
        expires.setTime(expires.getTime() + EXPIRE_COOKIE_POPUP_TIME);
        var cookie = "check_interests=" + $elm.data('btn') + ";expires=" + expires.toUTCString() +";path=/";
        Logger.debug("[cookie popup creada]");
        return document.cookie = cookie;
    }

    export function getUserDataText($arrayNames){
        var fieldText = '';
        var nameAux = '';
        for(var i=0;i<$arrayNames.length;i++){
            nameAux = ($arrayNames[i] == 'edad')?'fecha de nacimiento':$arrayNames[i];
            if (i == 0){
                fieldText = nameAux;
            }else if(i == ($arrayNames.length - 1)){
                fieldText = fieldText + ' y ' + nameAux;
            }else{
                fieldText = fieldText + ', ' + nameAux;
            }
        }
        $('.popup_user_data').find('.fieldstext').text('Por favor ¿Nos puedes facilitar tu ' + fieldText +'?');
    }

    export function checkUserData($elm, baseurl){

        var btn = $elm.data('btn');

        var fields = {};

        $('.popup_additional_data').find('select').each(function(){
            if(!fields.hasOwnProperty($(this).attr('name').split('.')[0])) {
                fields[$(this).attr('name').split('.')[0]] = [];
            }
            fields[$(this).attr('name').split('.')[0]].push($(this).attr('name').split('.')[1]);
        });

     //   Logger.debug('[listado fields]', fields);

        Voonto.$.ajax({
            url: baseurl + 'fields/show',
            xhrFields: {
                withCredentials: true
            },
            timeout: 10000
        }).fail(function(jqXHR, textStatus, errorThrown) {
            Logger.error('show fields module: retrieve ' + btn + ' error ', textStatus);
            return null;
        }).done(function(response){

            if (response && 'undefined' !== typeof response.code && response.code === 200) {
                var user = response.user;
                var countShow = 0;
                $('.popup_user_data').hide();
                $('.popup_user_data').removeClass('next_popup');
                $('.popup_user_data div').hide();
                $('.popup_user_data').find('div').each(function(){
                    $(this).removeClass('next_field');
                });
                $('.popup_user_data').find('select').each(function(){
                    $(this).attr('required',false);
                });
                $('.popup_user_interests').hide();
                $('.popup_user_interests').removeClass('next_popup');
                var arrayNames = [];
                Object.keys(fields).forEach(function (key) {
                    var field = fields[key];
                    Object.keys(field).forEach(function (i) {
                        if ((key == 'profile') && ((field[i] == 'birthDay')||(field[i] == 'birthMonth')||(field[i] == 'birthYear'))){
                            var currentDate = new Date();
                            if ((parseInt(user[key]['birthYear']) > (parseInt(currentDate.getFullYear()) - 13 )) ||(user[key]['birthDay'] === undefined) || (user[key]['birthMonth'] === undefined) || (user[key]['birthYear'] === undefined)){
                                $('.popup_user_data .popup_' + field[i]).addClass('next_field');
                                $('.popup_user_data .popup_' + field[i]).find('select').each(function(){
                                    if(user[key]['birthDay'] !== undefined){
                                        $('.popup_birthDay').find('.birthday').val(user[key]['birthDay'].length < 2 ? "0"+user[key]['birthDay'] : user[key]['birthDay']).change();
                                    }
                                    if(user[key]['birthMonth'] !== undefined){
                                        $('.popup_birthDay').find('.birthmonth').val(user[key]['birthMonth'].length < 2 ? "0"+user[key]['birthMonth'] : user[key]['birthMonth']).change();
                                    }
                                    if((parseInt(user[key]['birthYear']) <= (parseInt(currentDate.getFullYear()) - 13 )) && (user[key]['birthYear'] !== undefined)){
                                        $('.popup_birthDay').find('.birthyear').val(user[key]['birthYear']).change();
                                    }
                                });
                                countShow = countShow + 1;
                                if (field[i] == 'birthDay'){
                                    var nameField = $('.popup_user_data .popup_' + field[i]).find('label').attr('class').split('_')[1];
                                    if(arrayNames.indexOf(nameField) == -1){
                                        arrayNames.push(nameField);
                                    }
                                }
                            }
                        }else{
                            if (user[key][field[i]] === undefined || user[key][field[i]] === 'u'){
                                $('.popup_user_data .popup_' + field[i]).addClass('next_field');
                                countShow = countShow + 1;
                                arrayNames.push($('.popup_user_data .popup_' + field[i]).find('label').attr('class').split('_')[1]);
                            }
                        }
                    });
                });

                var username = ((user['profile']['firstName'] === undefined)?user['profile']['nickname']:user['profile']['firstName']);
                $('.popup_info .username').text(username);
                getInitialText(btn);
                getUserDataText(arrayNames);
                $('.popup_info').addClass('current_popup');
                $('.popup_info').show();
                if(countShow > 0){
                    $('.popup_additional_data').find('.popup_user_data').addClass('next_popup');
                }else{
                    $('.popup_additional_data').find('.popup_user_interests').addClass('next_popup');
                }
                $('.popup_additional_data').show();
            }

        });

    }

    export function updateAdditionalData(baseurl){

        var newfields = {};

        $('.popup_additional_data').find('.next_field select').each(function(){
            if ($(this).val() != ''){
                if(!newfields.hasOwnProperty($(this).attr('name').split('.')[0])) {
                    newfields[$(this).attr('name').split('.')[0]] = {};
                }
                newfields[$(this).attr('name').split('.')[0]][$(this).attr('name').split('.')[1]] = $(this).val();
            }
        });

        $('.popup_additional_data').find('.next_field select.birthday').attr('required',false);
        if($('.popup_additional_data').find('select.birthday').hasClass('next_field')){
            $('.popup_additional_data').find('.next_field select.birthday')[0].setCustomValidity('');
        }
        $('.popup_additional_data').find('.next_field select.birthmonth').attr('required',false);
        $('.popup_additional_data').find('.next_field select.birthyear').attr('required',false);
        
        if (($('.popup_additional_data').find('.next_field').hasClass('popup_birthDay')) && (($('.popup_additional_data').find('.next_field select.birthday').val()!='')||($('.popup_additional_data').find('.next_field select.birthmonth').val() !='')||($('.popup_additional_data').find('.next_field select.birthyear').val()!=''))){
            if (($('.popup_additional_data').find('.next_field select.birthday').val()=='')||($('.popup_additional_data').find('.next_field select.birthmonth').val() =='')||($('.popup_additional_data').find('.next_field select.birthyear').val()=='')){
                $('.popup_additional_data').find('.next_field select.birthday').attr('required','required');
                $('.popup_additional_data').find('.next_field select.birthmonth').attr('required','required');
                $('.popup_additional_data').find('.next_field select.birthyear').attr('required','required');
                $(".popup_user_data #form_fields")[0].reportValidity();
                return;
            }else{
                var date = $('.popup_additional_data').find('.next_field select.birthday').val() + '-' +
                    $('.popup_additional_data').find('.next_field select.birthmonth').val() + '-' +
                    $('.popup_additional_data').find('.next_field select.birthyear').val();
                if (!isValidDate(date)){
                    $('.popup_additional_data').find('.next_field select.birthday')[0].setCustomValidity("Revisa los elementos de la fecha");
                    $(".popup_user_data #form_fields")[0].reportValidity();
                    return;
                }
            }
        }

        if ( Object.keys(newfields).length > 0){

            var data = {'fields':newfields};

            $.ajax({
                type: 'post',
                url: baseurl + 'fields/update',
                data: data,
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                timeout: 10000
            }).fail(function(jqXHR, textStatus, errorThrown){
                Logger.error('additionaldata module update fields error: ', textStatus);
            }).done(function(response){
                savedData = true;
                getUserInterests();
                Logger.debug('[actualizar datos]',response);
            });

        }else{
            getUserInterests();
        }
    }

    export function isValidDate(s) {
        // format D(D)/M(M)/(YY)YY
        var dateFormat = /^\d{1,4}[\.|\/|-]\d{1,2}[\.|\/|-]\d{1,4}$/;

        if (dateFormat.test(s)) {
            // remove any leading zeros from date values
            s = s.replace(/0*(\d*)/gi,"$1");
            var dateArray = s.split(/[\.|\/|-]/);

            // correct month value
            dateArray[1] = dateArray[1]-1;

            // correct year value
            if (dateArray[2].length<4) {
                // correct year value
                dateArray[2] = (parseInt(dateArray[2]) < 50) ? 2000 + parseInt(dateArray[2]) : 1900 + parseInt(dateArray[2]);
            }

            var testDate = new Date(dateArray[2], dateArray[1], dateArray[0]);
            if (testDate.getDate()!=dateArray[0] || testDate.getMonth()!=dateArray[1] || testDate.getFullYear()!=dateArray[2]) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    }

    export function checkUserInterests($elm, baseurl) {

        Logger.info('additionaldata module interests');

        var btn = $elm.data('btn');

        Voonto.$.ajax({
            url: baseurl + 'interests/check',
            xhrFields: {
                withCredentials: true
            },
            timeout: 10000
        }).fail(function(jqXHR, textStatus, errorThrown) {
            Logger.error('show interests module: retrieve ' + btn + ' error ', textStatus);
            return null;
        }).done(function(response){
            if (response && 'undefined' !== typeof response.code && response.code === 200) {
                if(!response.hasinterests){
                    if (response.interestslist.length > 0){
                        $('.popup_user_interests #form_interests').html('');
                        for(var i=0;i<response.interestslist.length; i++){
                            var elem = response.interestslist[i];
                            var code = elem['code'];
                            $('.popup_user_interests #form_interests').append('<input id="' + code + '" type="checkbox" class="nibara-element" data-nibara-module="additionaldata" data-btn="checkinterests">');
                            if(code.substr(0, code.indexOf('.000'))+'.000' == code){
                                $('.popup_user_interests #form_interests').append('<label for="' + code + '">' + elem['category'] + '</label>');
                            }else if(elem.name != ''){
                                $('.popup_user_interests #form_interests').append('<label for="' + code + '">' + elem['name'] + '</label>');
                            }else{
                                $('.popup_user_interests #form_interests').append('<label for="' + code + '">' + elem['subcategory'] + '</label>');
                            }
                        }
                    }
                    $('.popup_user_interests #form_interests').find('input[type="checkbox"]').on('click', handleCheckedInterestsClick);
                    createPopupCookie($elm);
                    if (document.cookie.match(/^(.*;)?\s*check_interests\s*=\s*[^;]+(.*)?$/)){
                        checkUserData($elm, baseurl);
                    }
                }
            }
        });
    }

    export function handleCheckedInterestsClick(){
        var attr = $(this).attr('checked');
        if (typeof attr !== typeof undefined && attr !== false){
            $(this).removeAttr('checked');
        }else{
            $(this).attr('checked','checked');
        }
    }

    export function getUserInterests() {
        var currentcontainer = Voonto.$('.popup_user_interests');
        var oldnextcontainer = Voonto.$('.popup_additional_data').find('.current_popup');
        oldnextcontainer.hide();
        oldnextcontainer.removeClass('current_popup');
        currentcontainer.addClass('current_popup');
        currentcontainer.show();
    }


    export function updateUserInterests(baseurl){
        Logger.info('additionaldata module interests update');

        var interests = [];

        $('.popup_additional_data .popup_user_interests').find('input[type="checkbox"]').each(function(){
            var attr = $(this).attr('checked');
            if (typeof attr !== typeof undefined && attr !== false){
                var interest = {};
                interest['ID'] = $(this).attr('id');
                interest['type'] = 'manual';
                interest['status'] = (typeof attr !== typeof undefined && attr !== false)?true:false;
                interests.push(interest);
            }
        });

       // Logger.debug('interests checked: ', interests);

        if (interests.length > 0){
            var data = {'interests': interests};

            $.ajax({
                type: 'post',
                url: baseurl + 'interests/update',
                data: data,
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                timeout: 10000
            }).fail(function (jqXHR, textStatus, errorThrown) {
                Logger.error('additionaldata module update interests error: ', textStatus);
                var currentContainer = $('.popup_user_interests');
                currentContainer.hide();
                currentContainer.removeClass('current_popup');
                $('.popup_result').addClass('current_popup');
                $('.popup_result p.p1').html('<strong>¡Ha ocurrido un error!</strong>');
                $('.popup_result p.p2').text('Por favor, intentalo más tarde');
                $('.popup_result p.p2').show();
                $('.popup_result').show();
            }).done(function (response) {
                Logger.debug('additionaldata module update', response);
                if (response && 'undefined' !== typeof response.code && response.code === 200) {
                    Logger.debug('additionaldata module update ok', response);
                }
                var currentContainer = $('.popup_user_interests');
                currentContainer.hide();
                currentContainer.removeClass('current_popup');
                $('.popup_result').addClass('current_popup');
                $('.popup_result p.p1').html('<strong>¡Intereses guardados con éxito!</strong>');
                $('.popup_result p.p2').text('A partir de ahora, en ABC.es encontrarás información más personalizada según tus preferencias');
                $('.popup_result p.p2').show();
                $('.popup_result').show();
            });
        }else{
            var currentContainer = $('.popup_user_interests');
            currentContainer.hide();
            currentContainer.removeClass('current_popup');
            $('.popup_result').addClass('current_popup');
            if (savedData){
                $('.popup_result p.p1').html('<strong>¡Perfil actualizado con éxito!</strong>');
                $('.popup_result p.p2').text('Podrás seguir completando la información de tu perfil e indicando tus intereses favoritos más adelante en tu Área de Usuario en ABC.es');
                $('.popup_result p.p2').show();
            }else{
                $('.popup_result p.p1').text('Podrás seguir completando la información de tu perfil e indicando tus intereses favoritos más adelante en tu Área de Usuario en ABC.es');
                $('.popup_result p.p2').text('');
                $('.popup_result p.p2').hide();
            }
            $('.popup_result').show();
        }

    }

    export function checkInterest() {
        Logger.debug('check interest request');
        let urlReferer = document.referrer;
        let baseurl = '/ajax/v2/api/v1/';
        if (vocUserNotificationsPath !== undefined) {
            baseurl = vocUserNotificationsPath + baseurl;
        }
        Logger.debug('[post-script] baseurl: ' + baseurl);

        let timeoutPopupAddData = 0;
        if (urlReferer.includes("registro/validacion-mail.html")){
            let originRegister = window.location.href;
            let originText = 'register';
            if (originRegister.includes("/opinion/") && originRegister.includes(".html")){
                originText = 'opinion';
            }
            timeoutPopupAddData = getTimeoutPopup(originText);
            setTimeout(function () {
                if(!document.cookie.match(/^(.*;)?\s*check_interests\s*=\s*[^;]+(.*)?$/)){
                    let $elm = $('.gigya-registration-link').attr('data-btn', originText);
                    Logger.debug('[additionaldata_popup desde registro]');
                    checkUserInterests($elm,baseurl);
                }
            }, timeoutPopupAddData);
        }else{
            let originLogin = window.location.href;
            Logger.debug('[post-script] Origin login: ' + originLogin);
            if (!originLogin.includes("/micuenta/")){
                timeoutPopupAddData = getTimeoutPopup('login');
                setTimeout(function () {
                    if(!document.cookie.match(/^(.*;)?\s*check_interests\s*=\s*[^;]+(.*)?$/)) {
                        let $elm = $('.gigya-login-link').attr('data-btn', 'login');
                        Logger.debug('[additionaldata_popup desde login]');
                        checkUserInterests($elm, baseurl);
                    }
                }, timeoutPopupAddData);
            }
        }
    }

    export function updatedUserInfo(){
        return savedData;
    }

    /* Podemos Cargar esta en el scrip gigya.js y hacer un export/import */
    export function actionCustomService (action, event, id, section) {
              let app = Voonto.getInstance();
              app.when('vocuser:ready').then(function(gigyaUX) {
                if (typeof gigyaUX !== 'undefined') {
                  if ('update' === action) {
                    gigyaUX.updateCustomerServiceInCookieVocUser(id, section);
                    Logger.debug('[actionCS] CS Update id: '+id+', seccion: '+section);
                    if ('login' === event ) {
                      gigyaUX.showLogin();
                    } else if ('registro' === event) {
                      gigyaUX.showRegistration();
                    }
                  } else if ('send' === action ){
                    gigyaUX.sendCustomerService(id, section).done(function () {
                      Logger.debug('[actionCS] CS enviado id: '+id+', seccion: '+section);
                    });
                  }
                }
              });
            }


// WEBPACK FOOTER //
// ./src/scripts/article/additionaldata-script.js